import './Glance.scss';

import { Card, Col, Container, Row,  Carousel} from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';

import Button from '../../../../shared/components/Button';
import ContentRightsCard from '../components/ContentRightsCard';
import Moodboard from '../../../../shared/components/Moodboard/Moodboard';
import PaymentCard from '../components/PaymentCard';
import PropTypes from 'prop-types';
import React from 'react';
/* eslint-disable camelcase */
import { get } from 'lodash-es';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import queryString from 'query-string';
import userSession from '../../../../utils/userSession';

const Glance = ({ offer }) => {
  const userId = userSession('id');
  const lumanuEmail = userSession('lumanu_email');
  const { t } = useTranslation();
  const offerId = useSelector(store => get(store, 'offer.offerId'));
  const { token: accessToken } = queryString.parse(window.location.search);

  const userSignedUp = useSelector(store => get(store, 'offer.userSignedUp'));
  const showMoreDetails = !offer.is_seeding || (offer.is_seeding && userSignedUp);

  if (!offer) return null;

  let tokenPath = '';
  if (accessToken) {
    tokenPath = `?token=${accessToken}`;
  }

  const Deliverables = () => (
    <Col xs={12}>
      <Card className="mb-2">
        <Card.Header>
          <Card.Title className='mb-2'>
            {t('influencers.pages.campaign.glance.deliverables')}
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <p>{offer.is_optional_posting && t('influencers.pages.campaign.glance.optional_posting')}</p>
          {
            Object.keys(offer.deliverables)
              .filter(k => offer.deliverables[k] && k !== 'other')
              .map(key => {
                const amount = offer.deliverables[key];
                const name = t(`influencers.common.posts.${key}`, {
                  count: amount
                });
                return name ? (
                  <div key={name} className="text-1">
                    {amount} x {name}
                  </div>
                ) : null;
              })
          }
          {get(offer, 'deliverables.other') ?
            <div className="text-1">
              {offer.deliverables.other} x {offer.other_deliverable_label}
            </div> : null
          }
        </Card.Body>
        <Card.Footer>
          { showMoreDetails && 
          <Button to={`./${offerId}/brief#deliverables`} as={Link} variant="tertiary">
            {t('influencers.pages.campaign.more_details')}
            <i className="fal fa-arrow-right icon-right"></i>
          </Button> }
        </Card.Footer>
      </Card>
    </Col>
  );

  const Products = () => {
    const isEvent = offer.products[0].rtype === 'event admission';

    return (
      <Col xs={12}>
        <Card className="mb-2">
          <Card.Header>
            <Card.Title className='mb-2'>
              {isEvent
                ? t('influencers.pages.campaign.glance.event')
                : t('influencers.pages.campaign.glance.products')}
            </Card.Title>
          </Card.Header>
          <Card.Body>
            <div className="text-medium-1">
              {isEvent
                ? t('influencers.pages.campaign.glance.event_admission')
                : t('influencers.pages.campaign.glance.products_to_be_shipped')}
            </div>
            {
              offer.products.map(elem => (
                <div key={elem.id} className="product-item d-flex align-items-start gap-3 mt-3">
                  <div className="product-copy flex-grow-1">
                    <div className="text-1">{elem.name}</div>
                    <small
                      className="mt-1 d-block"
                      dangerouslySetInnerHTML={{ __html: elem.desc }}
                    />
                  </div>

                  {elem.pic && (
                    <img
                      src={elem.pic}
                      alt={elem.name}
                      className="product-thumb flex-shrink-0 ml-3"
                      width={80}
                      height={80}
                      loading="lazy"
                    />
                  )}
                </div>
              ))
            }
            <br />
            { offer.products_to_be_shipped_images.length > 0 &&
                <Carousel>
                  {offer.products_to_be_shipped_images.map((mediaUrl, index) =>
                    <Carousel.Item key={mediaUrl}>
                      <img src={mediaUrl}
                        key={mediaUrl}
                        style={{ maxWidth: "100%", maxHeight: "100%" }} />
                    </Carousel.Item>
                  )}
                </Carousel>
            }
          </Card.Body>
          <Card.Footer>
            { showMoreDetails &&
            <Button to={`./${offerId}/brand${tokenPath}`} as={Link} variant="tertiary">
              {t('influencers.pages.campaign.more_details')}
              <i className="fal fa-arrow-right icon-right"></i>
            </Button> }
          </Card.Footer>
        </Card>
      </Col>
    );
  };

  const MoodboardCard = () => (
    <Card>
      <Card.Header>
        <Card.Title className='mb-2'>{t('influencers.pages.campaign.moodboard.title')}
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Moodboard
          moodboardMedia={offer.moodboard_images}
          className='moodboard'
          rows={4} />
      </Card.Body>
    </Card>
  );

  const hasDeliverables = () => offer.deliverables && Object.keys(offer.deliverables).length > 0
    && Object.values(offer.deliverables).some(v => v > 0);

  const hasPayments = () => offer.payments && offer.payments.length > 0;

  const hasMediaRights = () => (!offer.hide_media_rights_price && offer.media_rights) || offer.show_content_rights_expiration_instructions;

  const hasProducts = () => offer.products && offer.products.length > 0;

  const hasImages = () => offer.moodboard_images && offer.moodboard_images.length > 0;

  if (!hasDeliverables() && !hasPayments() && !hasMediaRights() && !hasProducts() && !hasImages()) return null;

  return (
    <div className="offer-glance">
      <Container>
        <h3 className="text-center my-6">
          {
            offer.is_survey ?
              t('influencers.pages.campaign.glance.survey_title') :
              t('influencers.pages.campaign.glance.title')
          }
        </h3>
        <Row>
          <Col xs={12} sm={offer.moodboard_images ? 6 : 12}>
            <Row>
              <Col className='p-0' xs={12} sm={offer.moodboard_images ? 12 : 6}>
                {(!offer.is_survey && hasDeliverables()) && <Deliverables />}
                {hasProducts() && <Products />}
              </Col>
              <Col className='p-0' xs={12} sm={offer.moodboard_images ? 12 : 6}>
                {hasPayments() &&
                  <Col xs={12}>
                    <PaymentCard isLogged={!!userId} payments={offer.payments} incentives={offer.incentives}
                      lumanuEnabled={offer.lumanu_enabled}
                      lumanuEmail={lumanuEmail}
                      showMoreDetails={showMoreDetails} />
                  </Col>
                }
                {hasMediaRights() &&
                  <Col xs={12}>
                    <ContentRightsCard isLogged={!!userId} 
                      contentRights={offer.media_rights}
                      contentRightsExpirationInstructions={offer.show_content_rights_expiration_instructions &&
                        offer.content_rights_expiration_instructions} showMoreDetails={showMoreDetails} />
                  </Col>
                }
              </Col>
            </Row>
          </Col>
          {
            hasImages() &&
            <Col xs={12} sm={6} className={!offer.moodboard_images && 'd-none'}>
              <MoodboardCard />
            </Col>
          }
        </Row>
      </Container>
    </div >
  );
};

Glance.propTypes = {
  offer: PropTypes.object.isRequired
};

export default withRouter(React.memo(Glance));
